import { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { AlertCircle } from 'lucide-react';

interface RestrictedLayoutProps {
  children: ReactNode;
  permission: string;
}

export default function RestrictedLayout({ children, permission }: RestrictedLayoutProps) {
  const { currentUser, userProfile, isAdmin } = useAuth();
  
  // Vérifier si l'utilisateur a la permission requise
  const hasPermission = () => {
    // Super admin a toujours accès
    if (currentUser?.email === 'hosni@swipe-upp.com') {
      return true;
    }
    
    // Admin a accès à tout sauf assistant
    if ((isAdmin || userProfile?.userRole === 'admin') && permission !== 'assistant') {
      return true;
    }
    
    // Si l'utilisateur n'a pas de profil ou de permissions, il n'a pas accès
    if (!userProfile || !userProfile.permissions) {
      return false;
    }
    
    // Vérifier la permission spécifique
    return Boolean(userProfile.permissions[permission as keyof typeof userProfile.permissions]);
  };
  
  // Si l'utilisateur n'a pas la permission, afficher un message d'accès limité
  if (!hasPermission()) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="max-w-md w-full bg-white shadow-md rounded-lg border border-gray-200 p-6 text-center">
          <div className="flex flex-col items-center">
            <AlertCircle className="h-12 w-12 text-gray-400 mb-4" />
            <p className="text-gray-700 mb-1">
              Votre compte n'a pas encore reçu les permissions nécessaires pour accéder à cette fonctionnalité.
            </p>
            <p className="text-gray-700">
              Veuillez contacter l'administrateur de votre agence pour obtenir les accès appropriés.
            </p>
          </div>
        </div>
      </div>
    );
  }
  
  return <>{children}</>;
}